import firebase from "config/firebase";
export const requestForNewSchool =
  (data, onComplete = () => {}) =>
  () => {
    firebase
      .firestore()
      .collection("new-institute-requests")
      .add(data)
      .then(async (res) => {
        const notificationData = {
          createdAt: firebase.firestore.FieldValue.serverTimestamp(),
          type: "institute",
          notifyID: res.id,
          status: false,
        };
        await firebase
          .firestore()
          .collection("admin_notifiaction")
          .add(notificationData);
        onComplete();
      });
  };
